import { render, staticRenderFns } from "./indexInvite.vue?vue&type=template&id=0b73a2b0&scoped=true&"
import script from "./indexInvite.vue?vue&type=script&lang=js&"
export * from "./indexInvite.vue?vue&type=script&lang=js&"
import style0 from "./indexInvite.vue?vue&type=style&index=0&id=0b73a2b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b73a2b0",
  null
  
)

export default component.exports